export default "__VITE_ASSET__DJtjoaAZ__"